import { ErrorBoundary, Provider } from '@rollbar/react';
import Layout from 'components/layout';
import config from 'config';
import AppProviders from 'contexts/AppProviders';
import DevLogin from 'pages/DevLogin';
import ErrorLoadFailed from 'pages/Error/ErrorLoadFailed';
import type { FC } from 'react';
import AppRoutes from 'routes';

const rollbarConfig = {
  accessToken: config.rollbarAccessToken,
  environment: config.environment,
  enabled: config.environment !== 'development',
  // Off by default in rollbar.js, so throws inside event handlers and rejected promises went
  // unreported: ErrorBoundary only catches render errors.
  captureUncaught: true,
  captureUnhandledRejections: true,
  // Cross-origin scripts (extensions, third-party tags) surface as this placeholder with no
  // message and no stack, so it is pure noise.
  ignoredMessages: ['^Script error\\.?$'],
  payload: {
    client: {
      javascript: {
        source_map_enabled: true,
        guess_uncaught_frames: true,
      },
    },
  },
};

const App: FC = () => {
  // Dev-only fast login: render the bootstrap page bare (no Layout, which would fire authenticated
  // queries and sign us out before the session lands). See pages/DevLogin.
  if (import.meta.env.DEV && window.location.pathname === '/dev-login') {
    return <DevLogin />;
  }
  return (
    <Provider config={rollbarConfig}>
      <ErrorBoundary fallbackUI={ErrorLoadFailed}>
        <AppProviders>
          <Layout>
            <AppRoutes />
          </Layout>
        </AppProviders>
      </ErrorBoundary>
    </Provider>
  );
};

export default App;
